<template>
  <div class="flex">
    <div class="w-full">
      <div
        v-if="imgSrc"
        class="relative w-1/2"
      >
        <button
          class="absolute top-2 right-2 bg-gray-100 text-gray-950 rounded-full w-6 h-6 flex items-center justify-center hover:bg-gray-400 focus:outline-none"
          @click="$emit('clear-image')"
        >
          <icon
            icon="x"
            color="black"
            size="16px"
          />
        </button>
        <div class="min-h-[128px] w-full border-2 rounded border-dashed p-3">
          <img
            :src="imgSrc"
            alt="logo"
            class="max-h-[200px]"
          >
        </div>
      </div>
      <div
        v-else
        class="w-1/2"
      >
        <drag-n-drop
          validate
          file-type="image"
          @file-selected="handleFileSelected"
        />
        <button
          v-if="uploadEnabled && !hideUploadButton"
          class="bg-default_primary_dark hover:bg-default_primary_light text-default_white cursor-loading px-4 py-2 rounded mt-3"
          @click="uploadFile"
        >
          {{ imgSrc ? "change" : "Upload" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {computed, ref} from 'vue';
import DragNDrop from "@/javascript/views/clientDashboard/brand/dragNDrop.vue";
import Icon from "@/javascript/views/components/Icon.vue";

export default {
  name: 'ImageUploader',
  components: {Icon, DragNDrop},
  props: {
    imgSrc: {
      type: String,
      required: false
    },
    hideUploadButton: {
      type: Boolean,
      default: false
    }
  },
  emits: ['clear-image', 'upload-image', 'file-selected'],
  setup(_, { emit }) {
    const file = ref(null);

    const handleFileSelected = (selectedFile) => {
      file.value = selectedFile;
      emit('file-selected', file.value);
    };

    const uploadFile = async () => {
      emit('upload-image', file.value);
    };

    const uploadEnabled = computed(() => {
      return file.value;
    });

    return {
      handleFileSelected,
      uploadFile,
      uploadEnabled
    };
  },

};
</script>

<style scoped>
/* Add styles for image preview */
.image-preview {
  max-width: 100%;
  height: auto;
  margin-top: 10px;
}
</style>
